import * as types from "../../constants/actionTypes";
import moment from 'moment';

const initState = {
    isLoading: false,
    masterData: [],
    listUserMedis: [],
    formUserMedis: {
        f_nama_userm: "",
        f_email_userm: "",
        f_telepon_userm: "",
        f_hak_akses: "",
    },

};

export default function (state = initState, action) {
    switch (action.type) {
        case types.MODULE_USERMEDIS_SET_LOADER: {
            return{
                ...state,
                isLoading: action.payload
            }
        }
        case types.MODULE_USERMEDIS_MASTER_DATA_SUCCESS: {
            return{
                ...state,
                masterData: {
                    ...state.masterData,
                    [action.property] : action.value
                }
            }
        }
        case types.MODULE_USERMEDIS_HANDLE_STATE_FORM: {
            return {
                ...state,
                formUserMedis: {
                    ...state.formUserMedis,
                    [action.property]: action.value,
                }
            }
        }
        case types.MODULE_USERMEDIS_LISTDATA_USERMEDIS_SUCCESS: {
            return{
                ...state,
                listUserMedis: action.value
            }
        }

        default:
            return {
                ...state
            }
    }
}  